import { AdvisorTab } from '../AdvisorTab';
import { DiscountsTab } from '../DiscountsTab';
import { SpeedUpsTab } from '../SpeedUpsTab';

export const tabs = ['Advisor', 'Discounts', 'Speed Ups'];

export const tabContent = [<AdvisorTab />, <DiscountsTab />, <SpeedUpsTab />];
